import styled from 'styled-components';
import {
  brandBlack,
  whiteSphera,
  greenSp,
  grayLightSphera
} from 'src/utilities/UIStyles/variables/Colors';

export const BeneficiariesContainer = styled.div`
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 2.5%;
  background-color: ${whiteSphera};
  border-radius: 5px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  > h3 {
    width: 100%;
    text-align: center;
    color: ${greenSp};
  }
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const AddBeneficiary = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  > button {
    background-color: ${(props) => (props.totalPercentage >= 1 ? grayLightSphera : brandBlack)};
    border: none;
    border-radius: 5px;
    padding: 0.5% 3%;
    margin: 0 2% 3% 2%;
    color: ${whiteSphera};
    font-size: 1vw;
  }
`;
